module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "block_114",
    attrs: {
      "id": "id_Toc146373207"
    }
  }, [_c('span', {
    staticClass: "text_"
  }, [_vm._v("Chapter One"), _c('br', {}), _vm._v("Reality")])]), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Thump, thump, thump…")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Have you ever felt impotent? Powerless? Scared?")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I was sitting on the edge of a windowsill as two voices found their way to my ears.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Clean it up!” My ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("mother")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(", Shannon, shouted maliciously through gritted teeth. “Get off your ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("ass")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(" and clean up your own shit.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("While society considered it normal for parents to scream about cleaning, there was a secret seeping into the hard-wooden floorboards in the next room over. My half-naked ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("father")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(" was lying panic-stricken on the ground. He had literally shit the floorboards. The bitter scent of his faecal excrement was poorly covered by lavender moisturiser. I puddled this sad blob of dollar lotion into the palms of my hands and I held it closely up to my nose.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Give me something then! Give me a cloth!” He shouted back to her, mildly slurring his words.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“You can clean that shit with your own hands, you idiot!” She spat back sharply. Her voice slapped him just as hard as the back of the hand that followed.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("My eyes darted back out the window.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I felt a familiar knot in my stomach as my jaw tensed and my hands recoiled beneath their sleeves. My lavender blob failed to protect my nostrils from this fragrant molestation. My cold feet stuck clammy against the curtains; what would happen if I moved? Would it be my turn next? Would her fists find me at last? And if they did…would I then find the strength to tell my story?")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Shannon’s eyes found me. “It would be a ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("down right lie")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(", if you think for one second that I’m the bad guy here.” I didn’t say a word. “Why don’t you go and tell the school welfare leader that I’m hurting your little feelings again? Huh?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I felt a pounding loudly in my ears as Martin reached for his grey-stained hoodie and covered himself with it clumsily. Perhaps not realising that he had dragged his own shit across his thighs, he garbled, “Your mother is a big old teddy bear, Hope.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Shannon’s boots shadowed a path towards the kitchen and so began the cupboards slamming. Open and shut. Open and shut. Open and")]), _c('span', {
    staticClass: "text_7"
  }), _c('span', {
    staticClass: "text_8"
  }, [_vm._v("shit")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(". Martin hiccupped and hit his head against the floor—another wafting breeze and I gasped for breath.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Where did you put my smokes?” Her stern face reappeared.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I didn’t…” I mumbled faintly.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Uh-huh,” she snarled with cheap-beer-stained teeth. “You know the second your school psychologist sends welfare here, they are going to put you in a home with paedophiles, and your new brothers will be rapists. That’s what happens when you lie.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("She sucked the air between her teeth and left the room again.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I lifted my leg off the ledge and tiptoed past Martin. His eyes had rolled back to show two white balls twitching uncontrollably. I reached out to shake him awake, and his pupils rolled back to meet mine. He whispered, “She’s still watching,” and I looked up at the empty door frame. The corners of the ceiling seemed clear of cameras.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("My stomach tightened as I left Martin lying there alone.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I snuck up the stairs and closed my bedroom door, pressing it shut quietly with the full palm of my hand. The door handle stared at me accusingly, and I muttered an apology for not using it appropriately. Shannon warned me once before that door handles were not merely ornamental.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I opened my dresser and pulled out my backpack. The zip had latched onto a towel which I had hidden shamefully from the night before. I bent to rip this rough yellowing material from the zip and threw it hastily back inside. The corners of my room had no visible cameras. The curtains were tightly drawn. Supposedly, no one knew I had this towel.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I re-opened the wardrobe and shoved the towel deep inside my backpack.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("The stench of my father’s shit seeped through my nostrils again as I crept down the stairs. I felt the air around me stop moving, stale with the guilt of my escape. I turned the door handle, which rattled like they all did, and with a final backwards glance, I stepped out. The air filled my lungs deeply.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("When I reached the pavement, I paused to turn around. One open window on the second floor beckoned my gaze and dared it to hold still. So, I moved in the other direction, away from the large, deceitfully unwholesome house I was forced to call home. I bit down on my tongue, hard, because I didn’t want to cry and show the world that I was an overly sensitive and ridiculously dramatic ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("child.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I walked by the shadowy green of the leaves and the navy of the darkening sky; it seemed blurred somehow. My steady pace and the thump, thump, thumping in my brain led me on a straight path. A few mere doors down, not far from my school, I pulled on the latch of a white picket fence.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Her home was pretty and warm. It looked as though it should have been in a movie; as if someone should have witnessed its beauty and the perfect family within. I felt my shoulders relax. I needed this.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Thump, thump, thump; I knocked on their door and waited.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Hope, darling, come in,” Jane smiled brightly and stepped aside. “We are just cleaning up after Christina’s birthday party. She said you had a doctor’s appointment and couldn’t make it?” Her head tilted to the side with concern.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Uh, yeah,” I hesitated awkwardly.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Well, as long as you’re alright.” Jane swished her brown hair over her shoulder and added, “Head on up, she’s just in her room.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I pulled my sleeves down over my hands anxiously, a nervous habit, and I walked towards my friend. I stopped short at her doorway and licked my lips before speaking, “Hi, Christina!” She turned around gracefully, wearing a stunning red dress, perfect eyeliner, and a silky black headband to match.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Hope,” she gleamed. “You missed my birthday! Didn’t I invite you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("She and I held an understanding, and I gulped nervously. “Erm, you must have forgotten. That’s okay.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Oh, silly me,” she sang and reached down into a pile of clothes that were heaped on her bedroom floor. Lace, silk, satin, and I’m sure all things money can buy—her delicate fingers pulled at a bra-strap and tossed the article aside.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Yeah, hey, did you get any new books?” I changed the subject and walked towards her shelves.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Yep, like always, there are several new ones there that I’m not going to read.” I smelt her perfume closing in on me. “You know, you always ask me the same things, just take the books you want.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I knew she was right. I did a lot of the same things every day; like right at this moment, for instance, I was looking at her long brown hair and how beautifully curled and thick it was, like always. I often felt deep admiration for her. Yet the thought of growing my own long locks made me anxious. It wouldn’t be the same.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“You have a special lunch, tomorrow, don’t you?” I asked her.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Yes, I do.” Her eyes sparkled and she crossed her fingers. “Help me pick the perfect outfit?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Okay,” I muttered to the small of her back, and then paused. “I need to use your bathroom.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I walked to the back of her room and snuck into the glamorously tiled area. I held my breath as the door swung cleanly shut and clicked the lock. Gripping the strap of my bag, I swung it off and unzipped slowly. All corners of her bathroom seemed free of cameras, I knew this, but checked habitually.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("The yellow harsh fabric of my towel came out all too easily. By the time it was laid across her bathroom floor and staring up at me expectantly, all I could do was gulp. I bent down with an outreached hand, my right-hand gripping back onto the bag, but I froze.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Teenage girls masturbate. That’s what they are supposed to do.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("My pants fell to my ankles as I stood with my hands dropping awkwardly to my thighs. I laid half-naked on the towel squeezed shut my eyes. The coarse dryness of the sun-crusted towel against my skin had me wanting to scratch instantly. I shifted uncomfortably.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I reached down with my hands and began to feel the ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("area")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(". My lips turned downwards at the damp split section between my legs. I reminded myself that I had wiped myself with toilet paper the last time I peed. Two trembling fingers moved a little further downwards, through the ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("unnatural")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(" wetness and halted.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Was I missing some kind of plug?")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("My feet came parallel with the floor tiles and slid against the towel as I shot upright! I slipped and thudded against the floor. I reached down and pulled my pants up tightly. I wiped my fingers against the towel and dry retched silently to myself. Was the inside of a human body ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("supposed")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(" to be a taut tunnel of slimy wetness?")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("After the towel was shovelled back into my firmly zipped bag, I ran hot water straight onto my hands and scrubbed harshly. I wanted to wash off the disgusting feeling between my fingers. My shoulders seemed to have tightened up to my ears as I scanned the walls and peeked out the window.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Hope?” I suddenly knocked her hand-soap into the sink.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Jeez… I… I’m okay, I mean, I just had to—there was a spider in here—I’m almost done.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Okay then,” her tone was suspicious.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I skidded out of there to meet her crossed arms and tapping foot. Hot in the face, I dropped my bag and brushed the hair from my cheeks. Christina had changed into a black dress and gestured for me to make some kind of comment. “Your curtains are thick and secure in there, did you buy them recently?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("She rolled her eyes and I realised I had missed a beat.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“The dress looks amazing too,” I fumbled. “Did I say curtains? I meant dress. That’s a really secure…and thick…erm.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Let’s just go to sleep, Hope,” she huffed and switched off the light.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I let out a light exhale and pulled at the sleeping bag strings that were poking out from beneath her bed. She slid by me, fully clothed, and thumped her head against her pillow. My shoes and socks peeled from my feet and I blindly positioned them next to my backpack. Rolling out the sleeping bag, I slipped myself inside and waited.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("--")])]), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("When I woke up, I felt uncomfortable. Christina mumbled something about it being too cold and as my eyes opened, I saw her slender body exposed and in full. A perfect landscape. I lay frozen for a second, soaking in the abnormal occurrence. She would be the epitome of normal womanly form, and perhaps between her thighs, I could witness comparatively—did she have a tunnel through her core as well?")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Oh, oh no,” Christina whispered urgently. “No, no, no, no, oh my God!” She threw on her dressing gown and covered up the perfectly perfect skin I had knowingly been staring at. “My hair brush is gone!”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Groaning, and realising what a creepy friend I had become, I covered the blanket over my face and suggested, “Use a fork?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“What is wrong with you?” She shook her head disapprovingly. “Help me look for it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I could have helped her quite easily, instead of standing in the middle of the room awkwardly looking around, watching her with uncertainty. My eyes closed and all I could see were two perfectly rounded hips and a delicate spine that led right up to her neck. I knelt down to look underneath her bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Christina,” I began from the floor. “How do you know that your body is okay?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("I ")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v("am having a very important day.” She stomped over to look under the blanket. “I know my body is okay because I’m not a moron using a fork for a hairbrush.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I considered her words and obediently looked in silence.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("As my arms grew tired of looking under things, Christina huffed and stomped her foot. She looked at her phone and tossed it into her bag. Her robe came off suddenly again and I diverted my gaze. My bag was waiting for me in the corner, however I noticed the tip of my old yellow towel had found its way to poke out below the zip. I rushed over and pushed it back inside.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I’m going to the salon,” she announced at me, and I kept my eyes pinned to my backpack. “Earth to Hope?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I peeked to find her back in the red dress she had worn the night before. “Sorry,” I stumbled. “You kept being naked.” We both stared at each other.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Whatever, just—I’m going to the salon—so you can go to school and I’ll see you again tonight or something.” She waltzed out, throwing her purse over her shoulder hostilely. Her door closed behind her and I stepped back and sat on the edge of her bed. The palms of my hands felt warm against my eyes and I let my face stay hiding beneath them until it was time to go.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Walking to school, I gripped my backpack tighter as a man stepped out onto the sideway. He nodded and I kept my head down. The old lady three houses down would be standing on her porch and whispering quickly into her phone. Sometimes I thought I would hear the name Shannon, but I could never be sure.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Did it happen again?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I clasped at my heart. “Did what happen?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Your parents fighting?” I looked over to see my friend, Josh. He blinked at the camera dangling around his neck and flashing at our feet. It was bouncing against his chest protectively. He joined me through the school gate, patiently awaiting my reply, and we stood in line together by the nurse’s bay.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("He leaned against the wall with a playful smile across his thin lips. “I can always tell anyway. Even if you don’t tell me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Yes, okay there was another one.” We both took a step forward.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Well.” He raised a brow. “I thought we could do something after school? You don’t have to go home.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I don’t know, Josh.” His arm pressed against mine. I edged forward.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“You never come over anymore, Hope, what did I do?” I rolled up my left sleeve in preparation. He exhaled impatiently as I sat in the chair. The nurse looked at me with her old calloused eyes and flicked to find a vein. I scrunched up my eyes as the needle went in.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_7"
  }, [_vm._v("5…4…3…2…1…")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v("and it was out.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“You seriously give blood every month and still can’t look?” Josh shook his head. “Anyone would think you were afraid of needles.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I am. I just wish we didn’t have to do it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“You know,” he mused. “If you come over to my house later, I’ll make it all better…”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Put your camera down, Josh.” I reached out to redirect its lens. “I’m not coming over.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I can make you look like all the other girls,” he smirked. “You can borrow my cousin’s bra.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I pulled my sleeves down over my hands again. “I just don’t like being watched like that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Whatever, it would be old news anyway.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I sat at my desk and pursed my lips thoughtfully. Josh ran his fingers suggestively up and down the green camera strap. His tongue flicked out across his lip; he held my gaze.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I’ll think about it,” I spoke just before turning to face the front of the room.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Shuddering privately, I wondered if giving consideration—if seeking Josh’s approval and company—indicated a crush. I pushed my lead pencil hard into the desk until the tip broke. My hand trembled as I reached into my bag for the sharpener and felt the rough caress of my yellow associate.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Yanking my hand out, I turned on my seat and said, “Actually, I can’t visit you tonight. Sorry.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("The frustration on his face was clear as he started to click the button on his camera. I turned around slowly to face the blackboard, listening uncomfortably…click, click, click.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("--")])]), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("On my 12th birthday, my father sat across from me. “It is what it is.” He began to clap his slipper against the carpet. My feet were held together tightly in protest. “Shannon just wants the best for us both, you understand?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Her doctor gave her-s-wrong stuff.” He took one long puff from the cigarette in his left hand and sipped on the martini in his right. Blonde sticky hair glued to his cheeks and occasionally dipped into his cup. I straightened my back and wrapped my hands around my knees.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Okay,” I considered his words carefully. “But I didn’t say anything to her about it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("He sighed. “She had two beers, and that’s it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Excuse me,” Shannon emerged from the doorway with her yellowing teeth. “Some of us are trying to sleep!”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I stood up and pulled my hair back from my face. “I’m sorry.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Of course, you are.” She sucked the smoky air through her teeth. “You’re a ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("whiney little whore.")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Shannon.” Martin stood on wobbly legs and moved beside his wife. He raised a hand to her shoulder for steadying, humbly looking into her eyes, as any father might. “Hope’s too young for all that,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("She veered her beady black eyes towards me. “Well, someone has to tell her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("--")])]), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Click. Click. Clap—my pencil snapped.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_c('span', {
    staticClass: "text_3"
  }, [_c('br', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_7"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b727e48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_005.vue
// module id = 78
// module chunks = 0